/** Manda il titolo a capo su max 2 righe bilanciate, senza tagliare parole. */
function wrapTitle(title: string, maxLen = 26): [string, string] {
  const words = title.replace(/[<&>]/g, " ").split(/\s+/).filter(Boolean);
  const lines = ["", ""];
  let li = 0;
  for (const w of words) {
    if (li === 0 && (lines[0] + " " + w).trim().length > maxLen) li = 1;
    lines[li] = (lines[li] + " " + w).trim();
  }
  if (lines[1].length > 30) lines[1] = lines[1].slice(0, 29).trimEnd() + "…";
  return [lines[0], lines[1]];
}

function coverSvg(title: string, category: string): string {
  const safe = (s: string) => s.replace(/[<&>]/g, " ");
  const [l1, l2] = wrapTitle(title);
  // Titolo su due righe (adattivo): riga singola se corto, altrimenti va a capo.
  const titleBlock = l2
    ? `<text x="80" y="300" fill="#ecf4fb" font-size="58" font-weight="700" font-family="Space Grotesk, Arial, sans-serif">${safe(l1)}</text>
       <text x="80" y="372" fill="#ecf4fb" font-size="58" font-weight="700" font-family="Space Grotesk, Arial, sans-serif">${safe(l2)}</text>`
    : `<text x="80" y="336" fill="#ecf4fb" font-size="60" font-weight="700" font-family="Space Grotesk, Arial, sans-serif">${safe(l1)}</text>`;
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 630" width="1200" height="630">
      <defs>
        <linearGradient id="bg" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#020814"/>
          <stop offset="55%" stop-color="#04111f"/>
          <stop offset="100%" stop-color="#07192a"/>
        </linearGradient>
        <radialGradient id="glow" cx="78%" cy="24%" r="60%">
          <stop offset="0%" stop-color="rgba(33,224,235,0.22)"/>
          <stop offset="100%" stop-color="rgba(33,224,235,0)"/>
        </radialGradient>
      </defs>
      <rect width="1200" height="630" fill="url(#bg)"/>
      <circle cx="960" cy="150" r="300" fill="url(#glow)"/>
      <text x="80" y="150" fill="#21e0eb" font-size="24" letter-spacing="6" font-family="JetBrains Mono, monospace">${safe(category).toUpperCase()}</text>
      ${titleBlock}
      <text x="80" y="560" fill="#7fb8c8" font-size="24" font-family="Space Grotesk, Arial, sans-serif">Dimensione 4 di Dario Marco Bellini</text>
    </svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

/** Cover articolo: immagine reale se fornita, altrimenti SVG generato coerente col sito. */
export function BlogCover({
  title,
  category,
  coverImage,
  className,
}: {
  title: string;
  category: string;
  coverImage?: string;
  className?: string;
}) {
  // `|| ` (non `??`): il frontmatter puo` avere coverImage:"" (stringa vuota),
  // che va comunque trattata come "nessuna immagine" -> usa la cover SVG generata.
  const src = coverImage || coverSvg(title, category);
  return (
    <div className={`relative overflow-hidden rounded-2xl border border-[hsl(var(--border))] ${className ?? ""}`}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img src={src} alt="" aria-hidden="true" loading="lazy" decoding="async" className="h-full w-full object-cover" />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-background/70 via-transparent to-transparent" />
    </div>
  );
}
